import { Box, Grid, Typography, useTheme } from '@mui/material';
import parse from 'html-react-parser';
import React from 'react';
import StyledSecurity from './styles';

import { useTranslation } from 'react-i18next';
import IconCloud from '../../../components/Icons/IconSecurity/IconCloud';
import IconSecurityEye from '../../../components/Icons/IconSecurity/IconEyeSecurity';
import IconList from '../../../components/Icons/IconSecurity/IconList';
import IconLock from '../../../components/Icons/IconSecurity/IconLock';
import IconSetting from '../../../components/Icons/IconSecurity/IconSetting';
import IconShield from '../../../components/Icons/IconSecurity/IconShield';
import IconWall from '../../../components/Icons/IconSecurity/IconWall';



const Security = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const features1 = [
    { icon: <IconSecurityEye />, text: t('security-label-one') },
    { icon: <IconCloud />, text: t('security-label-two') },
    { icon: <IconWall />, text: t('security-label-three') },
    { icon: <IconLock />, text: t('security-label-four') },
    ,
  ];

  const features2 = [
    { icon: <IconList />, text: t('security-label-five') },
    { icon: <IconSetting />, text: t('security-label-six') },
    { icon: <IconShield />, text: t('security-label-seven') },
  ];

  return (
    <>
      <StyledSecurity>
        <Box
          sx={{
            backgroundColor: '#000',
            color: '#fff',
            textAlign: 'center',
            // py: 4,
            // px: 40,
            padding: '1.5% 10% 2.5% 10%',
            [theme.breakpoints.down('md')]: {
              padding: '10% 10% 13% 10%',
            },
          }}
        // style={{ padding: '0 16%' }}
        >
          <Box>
            {/* Title */}
            <Typography
              variant="h4"
              fontWeight="bold"
              gutterBottom
              sx={{
                fontSize: '48px',
                fontWeight: 800,
                lineHeight: '57.28px',
                mt: 1,
                [theme.breakpoints.down('md')]: {
                  mt: 1,
                  fontSize: '40px',
                  fontWeight: 800,
                  lineHeight: '47.73px',
                  mb: 2,
                },
              }}
            >
              {/* <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                  },
                }}
              // viewport={{ once: true }}
              > */}
              {t('security-title')}
              {/* </motion.div> */}
            </Typography>

            {/* Description */}
            <Typography
              variant="body1"
              sx={{
                // maxWidth: 800,
                margin: '0 auto',
                mb: 6,
                mt: 6,
                lineHeight: 1.8,
                fontSize: '20px',
                fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '600' : '700',
                lineHeight: '23.87px',
                [theme.breakpoints.down('md')]: {
                  mt: 3,
                  fontSize: '18px',
                  fontWeight: 600,
                  lineHeight: '23.4px',
                  mb: 5,
                },
              }}
            >
              {/* <motion.div
                initial={{
                  opacity: 0,
                  y: 100,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                    delay: 0.8,
                  },
                }}
              // viewport={{ once: true }}
              > */}
              {parse(t('security-desc'))}
              {/* </motion.div> */}
            </Typography>
          </Box>

          {/* Features Grid */}
          <Grid container spacing={{ xs: 5, md: 5, lg: 3, xl: 3 }} justifyContent="center">
            {features1.map((feature, index) => (
              <Grid item xs={6} sm={6} md={3} key={index}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      // backgroundColor: '#fff',
                      color: '#000',
                      borderRadius: '50%',
                      p: 0.2,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {feature.icon}
                  </Box>
                  {/* Text */}
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    sx={{
                      fontSize: '21.3px',
                      fontWeight: 600,
                      lineHeight: '25.42px',
                      mt: 3,
                      [theme.breakpoints.down('md')]: {
                        fontSize: '18px',
                        lineHeight: '21.48px',
                      },
                    }}
                  >
                    {feature.text}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
          {/* <Box sx={{ px: 15 }}> */}
          <Grid
            container
            spacing={{ xs: 5, md: 5, lg: 0, xl: 0 }}
            justifyContent="center"
            mt={8}
            sx={{
              [theme.breakpoints.down('md')]: {
                mt: 3,
              },
            }}
          >
            {features2.map((feature, index) => (
              <Grid
                item
                xs={6}
                sm={6}
                md={4}
                key={index}
                mt={5}
                sx={{
                  justifyContent: "center",
                  [theme.breakpoints.down('md')]: {
                    mt: 0,
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  {/* Icon */}
                  <Box
                    sx={{
                      // backgroundColor: '#fff',
                      color: '#000',
                      borderRadius: '50%',
                      p: 0.2,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {feature.icon}
                  </Box>
                  {/* Text */}
                  <Typography variant="body1" fontWeight="bold" sx={{
                    fontSize: '21.3px',
                    fontWeight: 600,
                    lineHeight: '25.42px',
                    [theme.breakpoints.down('md')]: {
                      fontSize: '18px',
                      lineHeight: '21.48px',
                      mt: 3,
                    },
                  }}>
                    {feature.text}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
          {/* </Box> */}
        </Box>
      </StyledSecurity >
    </>
  );
};

export default Security;
